import styled from 'styled-components';

export const UamRegistrationPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  h2 {
    font-size: 1.125rem !important;
  }
`;

export const UamErrorTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const UamErrorText = styled.p`
  color: #E0205D;
`;
